import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useMutation, useQueryClient } from 'react-query'
import { OEComponents } from '@opportunityeducation/oe-web-common'
import { showModal } from '../../../../actions/_modal'
import withApiData from '../../../HOC/withApiData'
import DraftJSRenderer from '../../../mini/DraftJSRenderer'
import UserAvatar from '../../../mini/UserAvatar'
import FlexAlignCenter from '../../../styled/FlexAlignCenter'
import { FlexAlignCenterCaption1 } from '../../../styled/typography/typographyExtentions'
import DeleteButton from '../../../styled/buttons/DeleteButton'
import { deleteMentorGuidance } from './API'
import { DeleteButtonWrapper, PencilIcon } from './styles'
import { MentorGuidanceContext } from './Index'
import { H5, P2 } from '../../../styled/typography/typography'
import ThreeDotMenu from '../../../mini/ThreeDotMenu'
import MutateMenu from '../../../mini/MutateMenu'
import { MutateMenuWrapper } from '../../../Student/UserCompiledQuest/Resources/styled'
import { deleteJourneyMentorResource } from '../../../MyCourses/Courses/API'
import useLexicon from '../../../../hooks/useLexicon'

const View = ({
  apiData,
  type,
  isMentor,
  guidance,
  onEditClick,
  onDelete,
  closeConfirmationModalAction,
  isJourney
}) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const lexicon = useLexicon()
  const mentorGuidanceContext = useContext(MentorGuidanceContext)
  const [anchorEl, setAnchorEl] = useState(null)
  const deleteMutation = useMutation(({ applyToAllSections }) =>
    deleteMentorGuidance(
      apiData,
      mentorGuidanceContext,
      type,
      guidance,
      applyToAllSections
    )
  )
  const onDeleteClick = applyToAllSections => {
    deleteMutation.mutate(
      {
        applyToAllSections
      },
      {
        onSuccess: () => {
          onDelete()
          queryClient.invalidateQueries('journey-mentor-guidance')
          queryClient.invalidateQueries('level-mentor-guidance')
        }
      }
    )
  }

  const handleMutateMenuClose = e => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    setAnchorEl(null)
  }

  const mutateMenuProps = {
    item: guidance,
    anchorEl: anchorEl,
    handleOpen: e => setAnchorEl(e.currentTarget),
    handleClose: handleMutateMenuClose,
    onEdit: () => {
      setAnchorEl(null)
      onEditClick()
    },
    userIsConsideringDeleting: e => {
      handleMutateMenuClose(e)
      dispatch(
        showModal('DELETE_MENTOR_GUIDANCE', {
          skillName: 'test',
          onCancel: () => {
            closeConfirmationModalAction()
          },
          onDelete: applyToAllSections => {
            onDeleteClick(applyToAllSections)
            closeConfirmationModalAction()
          }
        })
      )
    },
    openOnClick: true
  }

  return guidance ? (
    <div style={{ position: 'relative', maxWidth: '720px' }}>
      <FlexAlignCenter
        style={{ justifyContent: type === 3 ? 'start' :'space-between', marginBottom: '15px' }}
        onClick={isMentor ? onEditClick : null}
      >
        <FlexAlignCenter>
          {!isMentor && (
            <span style={{ marginRight: '11px' }}>
              <UserAvatar
                isMentor
                size={19}
                borderRadius={4}
                displayTooltip={false}
                photoUrl={guidance.applied_by.photo_url}
              />
            </span>
          )}
          <H5 as="h5" victoria>{lexicon.mentor_guidance}</H5>
        </FlexAlignCenter>
        {isMentor && (
          <FlexAlignCenterCaption1
            style={{ justifyContent: type === 3 ? 'flex-start' :'flex-end', marginLeft: type === 3 ? '13px' : '' }}
          >
            Last Saved: &nbsp;
            <OEComponents.ElapsedTimeFormatter time={guidance.updated_at} />
            {isJourney ? (
              <MutateMenu allowEdit {...mutateMenuProps} isJourney />
            ) :  <PencilIcon />}
          </FlexAlignCenterCaption1>
        )}
      </FlexAlignCenter>
      <div
        onClick={e => {
          e.stopPropagation()
          if (isMentor) {
            onEditClick()
          }
        }}
      >
        <DraftJSRenderer
          styleComponent={P2}
          content={guidance.text ? guidance.text : ''}
        />
      </div>
      {isMentor && !isJourney && (
        <DeleteButtonWrapper
          rightOffset={mentorGuidanceContext.rightOffsetDeleteButton}
          leftOffset={mentorGuidanceContext.leftOffsetDeleteButton ? mentorGuidanceContext.leftOffsetDeleteButton : ''}
        >
          <DeleteButton
            className="delete-mentor-guidance"
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()

              dispatch(
                showModal('DELETE_MENTOR_GUIDANCE', {
                  skillName: 'test',
                  onCancel: () => {
                    closeConfirmationModalAction()
                  },
                  onDelete: applyToAllSections => {
                    onDeleteClick(applyToAllSections)
                    closeConfirmationModalAction()
                  }
                })
              )
            }}
          />
        </DeleteButtonWrapper>
      )}
    </div>
  ) : null
}

View.propTypes = {
  apiData: PropTypes.object.isRequired,
  type: PropTypes.number.isRequired,
  isMentor: PropTypes.bool.isRequired,
  guidance: PropTypes.object,
  onEditClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  closeConfirmationModalAction: PropTypes.func.isRequired
}

export default withApiData(View)
